interface Props {
  className?: string
}

const DashboardIcon = ({ className }: Props): JSX.Element => (
  <svg
    className={className}
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="9" height="9" rx="2.8" fill="#FFFFFF" />
    <rect x="1" y="14.5" width="9" height="9" rx="2.8" fill="#FFFFFF" />
    <rect x="14.5" y="1" width="9" height="9" rx="2.8" fill="#FFFFFF" />
    <rect x="14.5" y="14.5" width="9" height="9" rx="2.8" fill="#FFFFFF" />
  </svg>
)

export default DashboardIcon
